import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {FusePageSimple} from '@fuse';
import { Menu, Chip, Paper, Grid, Button, Typography, SwipeableDrawer, Divider, List, ListItem, Dialog, DialogContent, DialogContentText, DialogActions, Select, MenuItem, TextField, FormControl, InputLabel, OutlinedInput, LinearProgress } from '@material-ui/core';
import Pagination from "material-ui-flat-pagination";

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';

import HomeIcon from '@material-ui/icons/Home';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import CompareIcon from '@material-ui/icons/CompareArrows';
import MenuIcon from '@material-ui/icons/Menu';
import CheckBoxRoundedIcon from '@material-ui/icons/CheckBoxRounded';

import GhostList from '../components/GhostList';

// import {ButtonUnduhExcel} from './../components/ButtonUnduhExcel';

const styles = theme => ({
    layoutRoot: {},
    headerUtama: {
        minHeight: 100
    }
});

// const options = [
//     { key: 10, text: 'Operator Sekolah', value: 10 },
//     { key: 11, text: 'Pengawas', value: 11 },
//     { key: 12, text: 'Peserta Didik', value: 12 },
//     { key: 53, text: 'Guru', value: 53 },
//     { key: 13, text: 'Komite Sekolah', value: 13 },
//   ]

class ManajemenPengguna extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            daftarPengguna: [],
            judul: 'Manajemen Pengguna',
            bottom: false,
            right: false,
            ListMenu: null,
            ListMenuKanan: null,
            dialog: false,
            namaDelete: '',
            offset: 0,
            halaman: 1,
            total: 0,
            displayProgres: 'none',
            data: {
                keyword: '',
                peran: 99,
                kandidat: 99
            },
            routeParams: {
                email: null
            }
            // filterPeran: 1,
            // filterNama: '',
            // options: [
            //     { key: 10, text: 'Operator Sekolah', value: 10 },
            //     { key: 11, text: 'Pengawas', value: 11 },
            //     { key: 12, text: 'Peserta Didik', value: 12 },
            //     { key: 53, text: 'Guru', value: 53 },
            //     { key: 13, text: 'Komite Sekolah', value: 13 },
            //   ]
        };

        this.toggleDrawer = this.toggleDrawer.bind(this);
    }

    hapusRecord = (pengguna_id) => {
        // alert(pengguna_id);
        this.props.setLoading('block');
        this.props.hapusPengguna(pengguna_id).then((result)=>{
            this.props.setLoading('none');

            fetch(localStorage.getItem('api_domain')+'/api/pengguna?token='+localStorage.getItem('jwt_token')+'&start='+this.state.offset+'&limit=20&keyword='+this.state.data.keyword+'&peran='+this.state.data.peran+"&sekolah_id="+JSON.parse(localStorage.getItem('user')).sekolah_id,{
                method: 'GET'
                // headers: {'Content-Type':'application/json'}
            })
            .then(res => res.json())
            .then(
            (result) => {
                // console.log(result);
                this.setState({
                    daftarPengguna: result.rows,
                    total: result.total
                });
    
                // console.log(this.state.daftarPengguna);
            });
        });
    }

    toggleKandidat = (option) => {
        this.props.setLoadingBesar(true);
        this.setState({
            ...this.state,
            routeParams: {
                ...this.state.routeParams,
                pengguna_id: option.pengguna_id,
                sekolah_id: option.sekolah_id,
                tahun: localStorage.getItem('tahun'),
                token: localStorage.getItem('jwt_token'),
                kandidat_responden_id: option.kandidat_responden_id
            }
        },()=>{

            this.props.setKandidat(this.state.routeParams).then((result)=>{
    
                fetch(localStorage.getItem('api_domain')+'/api/pengguna?kandidat='+this.state.data.kandidat+'&tahun='+localStorage.getItem('tahun')+'&token='+localStorage.getItem('jwt_token')+'&start='+(this.state.offset)+'&limit=20&keyword='+this.state.data.keyword+'&peran='+this.state.data.peran+"&sekolah_id="+JSON.parse(localStorage.getItem('user')).sekolah_id,{
                    method: 'GET'
                })
                .then(res => res.json())
                .then(
                    (result) => {
                        this.props.setLoadingBesar(false);
                        this.setState({
                            daftarPengguna: result.rows,
                            total: result.total
                        });
                        setTimeout(() => {
                            this.setState({displayProgres: 'none', isLoaded: true});
                        }, 1000);
                    }
                );
    
            });

        })
    }

    ubahRecord = (record) => {
        // alert('kepanggil nggak');
        this.props.history.push('/ProfilPengguna/'+record.pengguna_id);
    }

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    tukarPengguna = (email, pengguna_id) => (event) => {
        // alert(email);return true;
        this.props.setLoading('block');
        this.setState({
            ...this.state,
            routeParams: {
                ...this.state.routeParams,
                email: email,
                pengguna_id: pengguna_id,
                token: localStorage.getItem('jwt_token')
            }
        }, () => {
            localStorage.setItem('pengguna_id_ops', JSON.parse(localStorage.getItem('user')).pengguna_id);
            localStorage.setItem('email_ops', JSON.parse(localStorage.getItem('user')).email);

            this.props.tukarPengguna(this.state.routeParams).then((result)=>{
                // console.log(this.props.hasil_tukar_pengguna.token);
                localStorage.setItem('jwt_token', this.props.hasil_tukar_pengguna.token);
                localStorage.setItem('aslinya_ops', 1);
                localStorage.setItem('perlu_reload_lagi', "1");

                this.props.setLoading('none');
                window.location.href=localStorage.getItem('root_base');
                // window.location.reload(true);
            }); 
        });
    }

    toggleDrawer = (side, open, option) => (event) => {

        if(this.props.window_dimension.width <= 425){

            this.setState({ ...this.state, [side]: open });
            // console.log(option);
            
            // else{
            //     alert('record tidak ditemukan');
            // }
        }else{
            // alert('buka menu pengguna utama');
            this.setState({ anchorEl: event.currentTarget });
        }

        if(option){
            this.setState({
                ListMenu: (
                        <div style={{width: '100%', padding: 0}}>
                            <div style={{border: '0px solid red', width: '100%', textAlign: 'left'}}>
                                <div style={{padding: 10}}>
                                    <b style={{fontFamily: 'Helvetica, serif', fontWeight: 'bold', fontSize: 17}}>
                                        {option.nama}
                                    </b>
                                    <br/>
                                    {option.peran}
                                </div>
                                <Divider/>
                                <List>
                                    <ListItem button key="Tukar" style={{textAlign: 'left'}} onClick={this.tukarPengguna(option.email,option.pengguna_id)}>
                                        <CompareIcon/> <Typography>&nbsp;Tukar Pengguna</Typography>
                                    </ListItem>
                                    <ListItem button key="Ubah" style={{textAlign: 'left'}} onClick={() => {
                                        this.setState({
                                            bottom: false
                                        });

                                        this.ubahRecord(option);
                                    }}>
                                        <EditIcon/> <Typography>&nbsp;Profil</Typography>
                                    </ListItem>
                                    {/* {option.peran_id === 14 &&  */}
                                    <ListItem button key="Hapus" style={{textAlign: 'left'}} onClick={() => {
                                        this.setState({
                                            bottom: false,
                                            namaDelete: option.nama,
                                            penggunaIdDelete: option.pengguna_id,
                                            anchorEl: null
                                        },()=>{
                                            this.setState({
                                                ...this.state,
                                                dialog: true
                                            });
                                        });
                                        // alert(option.nama);
                                    }}>
                                        <DeleteIcon/> <Typography>&nbsp;Hapus</Typography>
                                    </ListItem>
                                    {/* } */}
                                    <ListItem button key="Kandidat" style={{textAlign: 'left'}} onClick={() => {
                                        this.setState({
                                            bottom: false,
                                            anchorEl: null
                                        },()=>{
                                            this.toggleKandidat(option);
                                        });

                                    }}>
                                        <CheckBoxRoundedIcon /> 
                                        {!option.kandidat_responden_id && <Typography>&nbsp;Pilih Kandidat Responden</Typography>}
                                        {option.kandidat_responden_id && <Typography>&nbsp;Batalkan Kandidat Responden</Typography>}
                                    </ListItem>
                                </List>
                            </div>
                        </div>
                        )
            })
        }

    };

    gotoBeranda = () => {
        this.props.history.push('/Beranda');
    };

    handleChange = name => event => {
        // console.log(name);
        console.log(event);

        // this.setState({
        //   [name]: event.target.value,
        // });

        let changedData = this.state.data;
        changedData[event.target.name] = event.target.value;
        changedData['update'] = 1;

        this.setState({
            data: changedData
        })
    };

    tambahPengguna = () => {
        this.setState({
            anchorEl: null
        });
        this.props.history.push('/TambahPengguna');
        // this.props.toggleFormPengguna(true, 'Tambah Pengguna');
        // alert('fungsi tambah');
        // this.setState({
        //     right: true
        // });


        // this.setState({
        //     ListMenuKanan: (
        //         <div style={{width: '100%', paddingTop: 10, background: 'white'}}>
        //             <Grid container>
        //                 <Grid item xs={3} style={{textAlign: 'left', paddingLeft: 10, border: '0px solid #ccc'}}>
        //                     <Button size="small" variant="outlined" color="primary" style={{minWidth: '40px'}}>
        //                         <SaveIcon /> Simpan
        //                     </Button>
        //                 </Grid>
        //                 <Grid item xs={6}>
        //                 </Grid>
        //                 <Grid item xs={3} style={{textAlign: 'right', paddingRight: 10, border: '0px solid #ccc'}}>
        //                     <Button size="small" variant="outlined" style={{minWidth: '40px'}} onClick={()=>{this.setState({right: false})}}>
        //                         <CloseIcon /> Tutup
        //                     </Button>
        //                 </Grid>
        //                 <Divider/>
        //             </Grid>
        //         </div>
        //     )
        // })
    };

    bukaMenuUtama = (event) => {
        // alert(window.innerWidth);
        // console.log(this.props.window_dimension);
        if(this.props.window_dimension.width <= 425){

            this.setState({ 
                ...this.state, 
                bottom: true
            });

        }else{
            // alert('tampilkan menu lebar');
            this.setState({ anchorEl: event.currentTarget });
        }

        const isiMenuUtama = (
            <div style={{width: '100%', padding: 0, height: 450}}>
                <div style={{border: '0px solid red', width: '100%', textAlign: 'left'}}>
                    <div style={{padding: 10}}>
                        <b style={{fontFamily: 'Helvetica, serif', fontWeight: 'bold', fontSize: 17}}>
                            Manajemen Pengguna
                        </b>
                    </div>
                    <Divider/>
                    <List>
                        <ListItem button key="Tambah" style={{textAlign: 'left'}} onClick={() => {
                                this.setState({
                                    bottom: false
                                });

                                this.tambahPengguna();
                            }}>
                            <AddIcon/> <Typography>&nbsp;Tambah</Typography>
                        </ListItem>
                        {/* <Divider/>
                        <ListItem button key="Salin Peserta Didik" style={{textAlign: 'left'}} onClick={() => {
                                this.setState({
                                    bottom: false
                                });

                                // this.tambahPengguna();
                                History.push("/DaftarPdDapodik/"+JSON.parse(localStorage.getItem('user')).sekolah_id);
                            }}>
                            <SyncIcon/> 
                            <Typography>&nbsp;Salin Peserta Didik dari Dapodik</Typography><br/>
                            
                        </ListItem>
                        <Divider/>
                        <ListItem button key="Salin PTK" style={{textAlign: 'left'}} onClick={() => {
                                this.setState({
                                    bottom: false
                                });

                                // this.tambahPengguna();
                                History.push("/DaftarPtkDapodik/"+JSON.parse(localStorage.getItem('user')).sekolah_id);
                            }}>
                            <SyncIcon/> <Typography>&nbsp;Salin PTK dari Dapodik</Typography>
                        </ListItem> */}
                        <Divider/>
                        <ListItem key="filterPeran" style={{textAlign: 'left'}}>
                            <div style={{width: '100%'}}>
                                <Grid container spacing={16}>
                                    <Grid item xs={12} sm={12} style={{marginTop: '-15px'}}>
                                    <TextField
                                        id="keyword"
                                        name="keyword"
                                        variant="outlined"
                                        label="Saring Nama/Username"
                                        className={this.props.textField}
                                        defaultValue={this.state.data.keyword}
                                        onChange={(event) => {
                                            // this.setState({
                                            //     bottom: false
                                            // });

                                            let changedData = this.state.data;
                                            changedData[event.target.name] = event.target.value;
                                            changedData['update'] = 1;

                                            this.setState({
                                                data: changedData
                                            });

                                            // console.log(this.state.data);
                                        }}
                                        onKeyDown={(e)=>{
                                            if(e.keyCode === 13){
                                                // console.log('value', e.target.value);
                                                // put the login here
                                                this.setState({
                                                    bottom: false,
                                                    isLoaded: false
                                                });

                                                this.setState({displayProgres: 'block'});
                                            
                                                fetch(localStorage.getItem('api_domain')+'/api/pengguna?kandidat='+this.state.data.kandidat+'&tahun='+localStorage.getItem('tahun')+'&token='+localStorage.getItem('jwt_token')+'&start=0&limit=20&keyword='+this.state.data.keyword+'&peran='+this.state.data.peran+"&sekolah_id="+JSON.parse(localStorage.getItem('user')).sekolah_id,{
                                                    method: 'GET'
                                                })
                                                .then(res => res.json())
                                                .then(
                                                    (result) => {
                                                        // console.log(result);
                                                        this.setState({
                                                            daftarPengguna: result.rows,
                                                            total: result.total
                                                        });
                                                        setTimeout(() => {
                                                            this.setState({displayProgres: 'none', isLoaded: true});
                                                        }, 1000);
                                                        
                                                        // console.log(this.state.daftarPengguna);
                                                });
                                            }
                                        }}
                                        margin="normal"
                                        style={{width: '100%'}}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        {/* <Select 
                                            placeholder='...' 
                                            id="saringPeran" 
                                            name="saringPeran" 
                                            options={this.state.options}
                                            defaultValue={this.state.filterPeran} 
                                            onChange={ this.handleChangeSelect }
                                            style={{width: '100%'}}
                                        /> */}
                                        <FormControl variant="outlined" className={this.props.formControl} style={{width: '100%'}}>
                                            <InputLabel htmlFor="saring-peran">Saring Jenis Responden</InputLabel>
                                            <Select
                                                placeholder="Saring Jenis Responden"
                                                variant="outlined"
                                                value={this.state.data.peran}
                                                // value={1}
                                                input={
                                                    <OutlinedInput
                                                    style={{width: '100%'}}
                                                    labelWidth={180}
                                                    id="peran"
                                                    name="peran"
                                                    onChange={this.handleChange}
                                                    // defaultValue={this.state.data.peran}
                                                    />
                                                }
                                                onChange={(event) => {

                                                    this.setState({
                                                        bottom: false,
                                                        isLoaded: false
                                                    });

                                                    console.log(event);
                                                    let changedData = this.state.data;
                                                    changedData[event.target.name] = event.target.value;
                                                    changedData['update'] = 1;

                                                    this.setState({
                                                        data: changedData
                                                    })

                                                    this.setState({displayProgres: 'block'});
                                            
                                                    fetch(localStorage.getItem('api_domain')+'/api/pengguna?kandidat='+this.state.data.kandidat+'&tahun='+localStorage.getItem('tahun')+'&token='+localStorage.getItem('jwt_token')+'&start=0&limit=20&keyword='+this.state.data.keyword+'&peran='+this.state.data.peran+"&sekolah_id="+JSON.parse(localStorage.getItem('user')).sekolah_id,{
                                                        method: 'GET'
                                                    })
                                                    .then(res => res.json())
                                                    .then(
                                                        (result) => {
                                                            // console.log(result);
                                                            this.setState({
                                                                daftarPengguna: result.rows,
                                                                total: result.total
                                                            });
                                                            setTimeout(() => {
                                                                this.setState({displayProgres: 'none', isLoaded: true});
                                                            }, 1000);
                                                            
                                                            // console.log(this.state.daftarPengguna);
                                                    });

                                                    console.log(this.state.data);
                                                }}
                                                name="peran"
                                                style={{width: '100%'}}
                                                >
                                                
                                                <MenuItem value={99}>
                                                    Semua
                                                </MenuItem>
                                                <MenuItem value={10}>Kepsek (Akun Operator Sekolah)</MenuItem>
                                                <MenuItem value={53}>Guru</MenuItem>
                                                {/* <MenuItem value={90}>Peserta Didik</MenuItem> */}
                                                {/* <MenuItem value={14}>Komite Sekolah</MenuItem> */}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FormControl variant="outlined" className={this.props.formControl} style={{width: '100%'}}>
                                            <InputLabel htmlFor="saring-kandidat">Saring Kandidat Responden</InputLabel>
                                            <Select
                                                placeholder="Saring Kandidat Responden"
                                                variant="outlined"
                                                value={this.state.data.kandidat}
                                                input={
                                                    <OutlinedInput
                                                    style={{width: '100%'}}
                                                    labelWidth={180}
                                                    id="kandidat"
                                                    name="kandidat"
                                                    onChange={this.handleChange}
                                                    />
                                                }
                                                onChange={(event) => {

                                                    this.setState({
                                                        bottom: false,
                                                        isLoaded: false
                                                    });

                                                    console.log(event);
                                                    let changedData = this.state.data;
                                                    changedData[event.target.name] = event.target.value;
                                                    changedData['update'] = 1;

                                                    this.setState({
                                                        data: changedData
                                                    });

                                                    this.setState({displayProgres: 'block'});
                                            
                                                    fetch(localStorage.getItem('api_domain')+'/api/pengguna?kandidat='+this.state.data.kandidat+'&tahun='+localStorage.getItem('tahun')+'&token='+localStorage.getItem('jwt_token')+'&start=0&limit=20&keyword='+this.state.data.keyword+'&peran='+this.state.data.peran+"&sekolah_id="+JSON.parse(localStorage.getItem('user')).sekolah_id,{
                                                        method: 'GET'
                                                    })
                                                    .then(res => res.json())
                                                    .then(
                                                        (result) => {
                                                            this.setState({
                                                                daftarPengguna: result.rows,
                                                                total: result.total
                                                            });
                                                            setTimeout(() => {
                                                                this.setState({displayProgres: 'none', isLoaded: true});
                                                            }, 1000);
                                                    });

                                                    console.log(this.state.data);
                                                }}
                                                name="kandidat"
                                                style={{width: '100%'}}
                                                >
                                                <MenuItem value={99}>
                                                    Semua
                                                </MenuItem>
                                                <MenuItem value={1}>Kandidat Responden</MenuItem>
                                                <MenuItem value={0}>Non-Kandidat Responden</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </div>
                        </ListItem>
                    </List>
                </div>
            </div>)
        
        this.setState({
            ListMenu: isiMenuUtama
        })

    }

    componentDidMount = () => {
        this.props.setJudul('Manajemen Pengguna');

        fetch(localStorage.getItem('api_domain')+'/api/pengguna?kandidat='+this.state.data.kandidat+'&tahun='+localStorage.getItem('tahun')+'&token='+localStorage.getItem('jwt_token')+'&start='+this.state.offset+'&limit=20&keyword='+this.state.data.keyword+'&peran='+this.state.data.peran+"&sekolah_id="+JSON.parse(localStorage.getItem('user')).sekolah_id,{
            method: 'GET'
            // headers: {'Content-Type':'application/json'}
        })
        .then(res => res.json())
        .then(
        (result) => {
            // console.log(result);
            this.setState({
                daftarPengguna: result.rows,
                total: result.total,
                // isLoaded: true
            });

            setTimeout(() => {
                this.setState({displayProgres: 'none', isLoaded: true});
            }, 1000);

            // console.log(this.state.daftarPengguna);
        });

        this.props.updateWindowDimension();

        window.addEventListener('resize', () => {
            // alert('tes');
            this.props.updateWindowDimension();
        });
    }

    loadData = (e, offset) => {
        this.setState({displayProgres: 'block', isLoaded: false});
        this.setState({offset: offset});
        console.log(offset);
        console.log(e);
        // console.log(offset, ((this.state.halaman-1)*20));
        
        fetch(localStorage.getItem('api_domain')+'/api/pengguna?kandidat='+this.state.data.kandidat+'&tahun='+localStorage.getItem('tahun')+'&token='+localStorage.getItem('jwt_token')+'&start='+(offset)+'&limit=20&keyword='+this.state.data.keyword+'&peran='+this.state.data.peran+"&sekolah_id="+JSON.parse(localStorage.getItem('user')).sekolah_id,{
            method: 'GET'
        })
        .then(res => res.json())
        .then(
            (result) => {
                // console.log(result);
                this.setState({
                    daftarPengguna: result.rows,
                    total: result.total
                });
                setTimeout(() => {
                    this.setState({displayProgres: 'none', isLoaded: true});
                }, 1000);
                
                // console.log(this.state.daftarPengguna);
        });

    }

    render()
    {
        const {classes} = this.props;
        const {bottom, ListMenu, ListMenuKanan, right, anchorEl} = this.state;
        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot,
                    header: classes.headerUtama
                }}
                header={
                    <div style={{width: '100%', minHeight: 100}}>
                        {/* <FormPengguna/> */}
                        <div className="p-16" style={{border: '0px solid #ccc', width: '100%'}}>
                            <Grid container spacing={16}>
                                <Grid item xs={10} sm={9}>
                                    {/* <h1 style={{fontSize: 25, fontFamily: 'Helvetica'}}>{this.state.judul}</h1> */}
                                    <Typography variant="caption">Guru yang tampil pada menu ini bersumber dari dapodik. Bila ada ketidaksesuaian, silakan lakukan penyesuaian pada aplikasi dapodik sekolah Anda</Typography>
                                </Grid>
                                <Grid item xs={2} sm={3} style={{textAlign: 'right'}}>
                                    {/* <Button size="small" variant="outlined" style={{margin: 'auto'}} className="buttonTambah">
                                        <AddIcon /> Tambah Pengguna
                                    </Button> */}
                                    <Button size="small" variant="outlined" style={{margin: 'auto', minWidth: '40px'}} className="buttonMenu" onClick={this.bukaMenuUtama}>
                                        <MenuIcon />
                                    </Button>
                                </Grid>
                            </Grid>
                        </div>

                        <div style={{minHeight: 10, width: '100%', background: '#4EBBE8'}}>
                            <Chip
                                icon={<HomeIcon/>}
                                label=""
                                className={this.props.classes.chip}
                                color="primary"
                                style={{justifyContent: 'start', marginLeft: 0, padding: 5, borderRadius: 0, borderRight: '1px solid #ccc', paddingLeft: '0px', paddingRight: '0px'}}
                                onClick={this.gotoBeranda}
                            />
                            <Chip
                                label="> Manajemen Pengguna"
                                className={this.props.classes.chip}
                                color="secondary"
                                style={{justifyContent: 'start', marginRight: 0, padding: 5, borderRadius: 0, paddingLeft: 0, paddingRight: 0, fontSize: 12}}
                            />
                        </div>
                    </div>
                }
                // contentToolbar={
                //     <div>
                //         <div className="px-16">
                //             <ButtonUnduhExcel text="Unduh Data 1" styles={{padding: '10px', background: 'red', color: 'white'}} onClick={function() {
                //                 alert('button 1')
                //             }}/>
                //             <ButtonUnduhExcel text="Unduh Data 2" styles={{padding: '10px', background: 'green', color: 'white'}} onClick={function() {
                //                 alert('button 2')
                //             }}/>
                //         </div>
                //         {/* <div className="px-16"><ButtonUnduhExcel text="Unduh Data 2"/></div> */}
                //         {/* {ButtonUnduhExcel('Ambil Data')} */}
                //     </div>
                // }
                content={
                    // <FuseAnimate
                    // animation="transition.slideUpIn"
                    // duration={400}
                    // delay={400}
                    // >
                    <div className="p-8 kontenManajemenPengguna konten-utama">
                        <Paper className="rounded elevation5">
                            <Grid container>
                                <Grid item xs={12} sm={12}>
                                </Grid>
                                <Grid item xs={12} sm={12} style={{textAlign: 'right'}}>
                                        <Pagination
                                        limit={20}
                                        offset={this.state.offset}
                                        total={this.state.total}
                                        innerButtonCount={1}
                                        style={{width: '100%'}}
                                        onClick={this.loadData}
                                        />
                                        <LinearProgress style={{display: this.state.displayProgres}}/>
                                </Grid>
                            </Grid>
                        </Paper>
                        <br/>
                        {this.state.isLoaded === false && <div>
                            <GhostList/>
                            <GhostList/>
                            <GhostList/>
                            <GhostList/>
                            <GhostList/>
                            <GhostList/>
                        </div>}
                        {this.state.daftarPengguna.map((option) => (
                            <Paper className="rounded elevation5" style={{padding: 10, marginBottom: 5}} key={option.pengguna_id}>
                                <Grid container>
                                    <Grid item xs={3} sm={1}>
                                        <Paper style={{width: 65, height: 65, background: 'url(http://'+window.location.host+'/assets/images/avatars/avatar.gif)',backgroundSize: '100%', margin: 'auto'}}>
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={8} sm={10}>
                                        <Grid container>
                                            <Grid item xs={12} sm={6} style={{borderLeft: '1px solid #ccc', paddingLeft: 10}}>
                                                <b style={{fontSize: 14}}>{option.nama}</b>
                                                <br/>Username: <span style={{color:'#1e90ff'}}>{option.email}</span>
                                                <br/>Jenis Responden: {option.peran}
                                                
                                                <br/>
                                                {option.kandidat_responden_id && <Typography variant="caption" style={{color:'green',fontWeight: 'bold'}}>Kandidat Responden pengisi instrumen</Typography>}
                                                {!option.kandidat_responden_id && <Typography variant="caption"></Typography>}
                                            </Grid>
                                            <Grid item xs={12} sm={6} style={{borderLeft: '1px solid #ccc', paddingLeft: 10}}>
                                                NIK: {option.nik}
                                                <br/>NISN/NUPTK: -
                                                <br/>{option.peran_id === 90 && <Typography>Tingkat Kelas: {option.bidang_studi_id_str}</Typography>}{option.peran_id === 53 && <Typography>Bidang Studi: {option.bidang_studi_id_str}</Typography>} 
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={1} sm={1} style={{marginTop: 5, borderLeft: '0px solid #ccc', paddingLeft: 10}}>
                                        {/* <Button size="small" style={{float: "right", background: '#008CB7', color: 'white', marginBottom: 5, marginLeft: 5, minWidth: '40px'}}>
                                            <EditIcon className={classes.extendedIcon} style={{color: 'white'}} />
                                            <Typography style={{color: 'white', paddingLeft: '10px'}}>Ubah</Typography>
                                        </Button> */}
                                        <Button 
                                            size="small" 
                                            style={{
                                                float: "right", 
                                                background: '#ffffff', 
                                                color: '#ccc', 
                                                marginBottom: 5, 
                                                minWidth: '40px'
                                            }} 
                                            onClick={this.toggleDrawer('bottom', true, option)}>
                                            <MenuIcon className={classes.extendedIcon} style={{color: '#ddd'}} />
                                        </Button>
                                    </Grid>
                                    {/* <Grid item xs={12}>
                                        <br/>
                                        {!option.kandidat_responden_id && <Typography variant="caption" style={{color:'green',fontWeight: 'bold'}}>Kandidat Responden pengisi instrumen</Typography>}
                                        {option.kandidat_responden_id && <Typography variant="caption">-</Typography>}
                                    </Grid> */}
                                </Grid>
                            </Paper>
                        ))}
                        <Menu
                            id="simple-menu"
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={this.handleClose}
                            >
                            {ListMenu}
                        </Menu>
                        <SwipeableDrawer
                            anchor="bottom"
                            open={bottom}
                            onClose={this.toggleDrawer('bottom', false, null)}
                            onOpen={this.toggleDrawer('bottom', true, null)}
                        >
                            <div style={{padding: 0, minHeight: 100, maxHeight: 400, overflow: 'auto'}}>
                                {ListMenu}
                            </div>
                        </SwipeableDrawer>
                        <SwipeableDrawer
                            anchor="right"
                            open={right}
                            onClose={() => this.setState({right: false})}
                            onOpen={() => this.setState({right: true})}
                            className="drawerKanan"
                        >
                            <div 
                            className="wadahDrawerKanan"
                            style={{
                                padding: 0, 
                                minHeight: 100, 
                                width: '100%', 
                                overflow: 'auto',
                                // maxWidth: '700px',
                                height: '100%',
                                background: '#ffffff',
                                margin: 'auto',
                                marginTop: '0px'
                            }}>
                                {ListMenuKanan}
                            </div>
                        </SwipeableDrawer>
                        <Dialog
                            open={this.state.dialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogContent>
                                <DialogContentText>
                                    Apakah Anda yakin ingin menghapus data {this.state.namaDelete}?
                                </DialogContentText>
                                <DialogActions>
                                    <Button color="primary" onClick={() => {
                                        this.setState({
                                            dialog: false
                                        },()=>{
                                            this.hapusRecord(this.state.penggunaIdDelete);
                                        });

                                    }}>
                                        Ya
                                    </Button>
                                    <Button color="primary" onClick={()=>{
                                        this.setState({
                                            dialog: false
                                        })
                                    }}>
                                        Tidak
                                    </Button>
                                </DialogActions>
                            </DialogContent>
                        </Dialog>
                    </div>
                    // </FuseAnimate>
                }
            />
        )
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getPengguna: Actions.getPengguna,
        hapusPengguna: Actions.hapusPengguna,
        getPeran: Actions.getPeran,
        toggleFormPengguna: Actions.toggleFormPengguna,
        updateWindowDimension: Actions.updateWindowDimension,
        tukarPengguna: Actions.tukarPengguna,
        setLoading: Actions.setLoading,
        setLoadingBesar: Actions.setLoadingBesar,
        setJudul: Actions.setJudul,
        setKandidat: Actions.setKandidat
    }, dispatch);
}

function mapStateToProps({ Pengguna, App }) {

    return {
        pengguna: Pengguna.pengguna,
        peran: Pengguna.peran,
        toggle_form_pengguna: Pengguna.toggle_form_pengguna,
        window_dimension: App.window_dimension,
        hasil_tukar_pengguna: Pengguna.hasil_tukar_pengguna,
        loading: App.loading
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(ManajemenPengguna)));

// export default withStyles(styles, {withTheme: true})(ManajemenPengguna);


// WEBPACK FOOTER //
// ./src/main/content/Pengaturan/ManajemenPengguna.js